import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  container: (props: any) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    display: props.isBeingProcessed ? 'flex' : 'none',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    rowGap: '1.5rem',
    fontSize: '1rem',
    backgroundColor: theme.whiteColor,
    color: theme.darkSlateGrayColor,
  }),
  isBeingProcessed: {
    textTransform: 'uppercase',
  },
  ifYouAreNotRedirected: {
    fontFamily: theme.fontFamilyQuestrial,
  },
  redirect: {
    color: theme.lightPinkColor,
    textTransform: 'uppercase',
  },
}));

export default useStyles;
